import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';
import * as angular from 'angular';

export class AncCallSeatsMapService {

    constructor (
        private AncillariesConstants: AncillariesConstant,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private AncillariesUtilsService: AncillariesUtilsService,
        private CommonsNewHttpUtilsErrorService: CommonsNewHttpUtilsErrorService,
        private CommonsGenericProxy: CommonsGenericProxy) { }



    getSeatsMap = (segmentId: string) => {
        const flowId = this.localStorageService.get('flowId');
        const endpoint = this.AncillariesUtilsService.getEndpoint('sea-cism-rs') || this.AncillariesConstants.DEFAULT_ENDPOINTS.seatsMapURI;
        const uri = endpoint + flowId + '/flight/' + segmentId + (this.AncillariesUtilsService.isCheckinFlow() ? '/seatmap' : '/seatmapLayout');
        return new Promise((resolve, reject) => {
            this.CommonsGenericProxy.getGeneric(uri).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                });
        });
    };

    selectSeats = (seatsInfo: any, segmentId: string) => {
        const flowId = this.localStorageService.get('flowId');
        const endpoint = this.AncillariesUtilsService.getEndpoint('sea-cism-rs') || this.AncillariesConstants.DEFAULT_ENDPOINTS.seatsMapURI;
        const uri = endpoint + flowId + '/flight/' + segmentId;
        const data: any = angular.toJson(seatsInfo);
        return new Promise((resolve, reject) => {
            this.CommonsGenericProxy.putGeneric(uri, data).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                });
        });
    };
}
AncCallSeatsMapService.$inject = ['AncillariesConstants', 'localStorageService', 'AncillariesUtilsService', 'CommonsNewHttpUtilsErrorService', 'CommonsGenericProxy'];
try {
    const mod = angular.module('ib-web-ancillaries-services-module');
    mod.service(
        'AncCallSeatsMapService',
        AncCallSeatsMapService
    );
} catch (error) {
    const mod = angular.module('ib-web-ancillaries-services-module', []);
    mod.service(
        'AncCallSeatsMapService',
        AncCallSeatsMapService
    );
}